 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		7: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"85986571fa46085198d72e11cc0a9f9198a101e5","2":"985650a0e1bcfdd3b6cf147cae24fc7faf5cead6","3":"4d8f7713b91f7d35f217f7a1d1e898a2ff384616","4":"781c107af9d31c07f4be72d9322cab66ac849368","5":"38f81b1f48daa0d4745648e49fb06c2209227aac","6":"framework","9":"component---gatsby-theme-husky-src-templates-404-404-tsx","10":"component---gatsby-theme-husky-src-templates-article-about-strepsils-page-index-tsx","11":"component---gatsby-theme-husky-src-templates-article-symptoms-page-index-tsx","12":"component---gatsby-theme-husky-src-templates-contact-us-page-contact-us-page-tsx","13":"component---gatsby-theme-husky-src-templates-home-page-home-page-tsx","14":"component---gatsby-theme-husky-src-templates-lds-page-lds-page-tsx","15":"component---gatsby-theme-husky-src-templates-product-page-product-page-tsx","16":"component---gatsby-theme-husky-src-templates-product-quiz-page-product-quiz-page-tsx","17":"component---gatsby-theme-husky-src-templates-products-list-page-products-list-page-tsx","18":"component---gatsby-theme-husky-src-templates-search-result-page-search-result-page-tsx","19":"component---gatsby-theme-husky-src-templates-site-map-page-site-map-page-tsx"}[chunkId]||chunkId) + "-" + {"0":"754f9b5fc820d80194bc","1":"1820a22943cbfb2ed986","2":"fc9516c955593a79195d","3":"990b9af55159e5169e3d","4":"bc49bf9da3a87b4c0803","5":"5c07eb71edc8ac928a9e","6":"b0df79052ff91152e44d","9":"1953933b8fe58cda7b6e","10":"ce15f3e28bcfab880d1e","11":"0718f930dfaa414e16a3","12":"73942228f951bf47532f","13":"92e5816d55fe3c2e436e","14":"75c9a47534d3ff628377","15":"b208b0820c6a2943296b","16":"1ce17a6de2c0f0a85c11","17":"09305a29f48d46fe8875","18":"a99231c9709db44f4ad3","19":"002cf64047b255c2f95c","22":"5f39d674d2b723ff1e30","23":"7b9f8232efd78ad096e5","24":"2a8260eaf7acb34150a2","25":"8d9dfb49d66604029775","26":"8e7c9f2703ad1e7d3293","27":"20f1bd816b055e015140"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"85986571fa46085198d72e11cc0a9f9198a101e5","2":"985650a0e1bcfdd3b6cf147cae24fc7faf5cead6","3":"4d8f7713b91f7d35f217f7a1d1e898a2ff384616","4":"781c107af9d31c07f4be72d9322cab66ac849368","5":"38f81b1f48daa0d4745648e49fb06c2209227aac","6":"framework","9":"component---gatsby-theme-husky-src-templates-404-404-tsx","10":"component---gatsby-theme-husky-src-templates-article-about-strepsils-page-index-tsx","11":"component---gatsby-theme-husky-src-templates-article-symptoms-page-index-tsx","12":"component---gatsby-theme-husky-src-templates-contact-us-page-contact-us-page-tsx","13":"component---gatsby-theme-husky-src-templates-home-page-home-page-tsx","14":"component---gatsby-theme-husky-src-templates-lds-page-lds-page-tsx","15":"component---gatsby-theme-husky-src-templates-product-page-product-page-tsx","16":"component---gatsby-theme-husky-src-templates-product-quiz-page-product-quiz-page-tsx","17":"component---gatsby-theme-husky-src-templates-products-list-page-products-list-page-tsx","18":"component---gatsby-theme-husky-src-templates-search-result-page-search-result-page-tsx","19":"component---gatsby-theme-husky-src-templates-site-map-page-site-map-page-tsx"}[chunkId]||chunkId) + "." + {"0":"c3909a6ccc17aaf69629","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","9":"eb6de9d72030a786dd73","10":"f0b9db1fb28890b0e3e9","11":"280050c5fe73f8c9c305","12":"058cdc5b2d3806bbe698","13":"969c41f7e5559c765144","14":"8339e0795ca606108422","15":"ded6a6bd701f043fed8f","16":"d92a94c9e9e25f7ba011","17":"7d4f49501d1e5bbcad84","18":"b773297ede3079ef2a5a","19":"b7560e8ce7a20d872ce2","22":"71f642986343521409c3","23":"a9c5c01c1d383b3d0bd3","24":"7005f88c9b1f1b5c216d","25":"f43d9df51d04124d05d9","26":"8ae98bb9ac07817fb43b","27":"b87f36b2210c5126b4f1"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
